module.exports = __webpack_public_path__ + "img/ico_new_1.3c4946f0.svg";